export default "__VITE_ASSET__73b7f5d6__"